<p-divider />
<p class="mt-2 mb-1">{{'auth.passwordRules' | translate}}</p>
<ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
  <li>
    {{'auth.atLeastOneLowercase' | translate}}
    <i [class]="isAccomplished(atLeastOneLowercase, password) ? 'fa fa-check' : 'fa fa-xmark danger'"
       [ngStyle]="{'color': isAccomplished(atLeastOneLowercase, password) ? 'green' : 'red'}">
    </i>
  </li>
  <li>
    {{'auth.atLeastOneUppercase' | translate}}
    <i [class]="isAccomplished(atLeastOneUppercase, password) ? 'fa fa-check' : 'fa fa-xmark danger'"
       [ngStyle]="{'color': isAccomplished(atLeastOneUppercase, password) ? 'green' : 'red'}"></i>
  </li>
  <li>
    {{'auth.atLeastOneNumeric' | translate}}
    <i [class]="isAccomplished(atLeastOneNumeric, password) ? 'fa fa-check' : 'fa fa-xmark danger'"
       [ngStyle]="{'color': isAccomplished(atLeastOneNumeric, password) ? 'green' : 'red'}"></i>
  </li>
  <li>
    {{'auth.atLeastOneSpecialCharacter' | translate}}
    <i [class]="isAccomplished(atLeastOneSpecialCharacter, password) ? 'fa fa-check' : 'fa fa-xmark danger'"
       [ngStyle]="{'color': isAccomplished(atLeastOneSpecialCharacter, password) ? 'green' : 'red'}"></i>
  </li>
  <li>
    {{'auth.minimumNineCharacters' | translate}}
    <i [class]="isAccomplished(atLeast9Characters, password) ? 'fa fa-check' : 'fa fa-xmark danger'"
       [ngStyle]="{'color': isAccomplished(atLeast9Characters, password) ? 'green' : 'red'}"></i>
  </li>
</ul>
